export default "__VITE_ASSET__BUqVxm2q__"